import { render } from "./TrendingMerchants.vue?vue&type=template&id=726f4766&scoped=true"
import script from "./TrendingMerchants.vue?vue&type=script&lang=js"
export * from "./TrendingMerchants.vue?vue&type=script&lang=js"

import "./TrendingMerchants.vue?vue&type=style&index=0&id=726f4766&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-726f4766"]])

export default __exports__